import {
    CATEGORY_DELETE_SUCCESS,
    CATEGORY_DELETE_START,
    CATEGORY_DELETE_ERROR
} from '../../../constants/index';
import { setLoaderComplete, setLoaderStart } from '../../loader/loader'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { deleteSubCategoryMutation as mutation, getAllSubCategory } from '../../../lib/graphql';

export const deleteSubCategory = (id, currentPage) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CATEGORY_DELETE_START
            });
            dispatch(setLoaderStart('DeleteSubCategory'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id
                },
                refetchQueries: [{ query: getAllSubCategory, variables: { currentPage, searchList: '' } }]
            });

            if (data?.deleteSubCategory?.status == 200) {
                dispatch({
                    type: CATEGORY_DELETE_SUCCESS
                });
                showToaster({ messageId: 'removeSubCatSuccess', toasterType: 'success' });

            } else {
                dispatch({
                    type: CATEGORY_DELETE_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.deleteSubCategory?.errorMessage }, toasterType: 'error' });
            }
            dispatch(setLoaderComplete('DeleteSubCategory'));
        } catch (err) {
            dispatch({
                type: CATEGORY_DELETE_ERROR
            });
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
            dispatch(setLoaderComplete('DeleteSubCategory'));

        }
    }
};